"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarginAnalysisReportSchema = exports.MarginProductRowSchema = exports.MarginCategoryRowSchema = void 0;
const zod_1 = require("zod");
exports.MarginCategoryRowSchema = zod_1.z.object({
    categoryId: zod_1.z.string(),
    categoryName: zod_1.z.string(),
    revenue: zod_1.z.number(),
    cost: zod_1.z.number(),
    grossProfit: zod_1.z.number(),
    marginPct: zod_1.z.number(),
    unitsSold: zod_1.z.number(),
});
exports.MarginProductRowSchema = zod_1.z.object({
    productId: zod_1.z.string(),
    variantId: zod_1.z.string().optional(),
    name: zod_1.z.string(),
    sku: zod_1.z.string().optional(),
    categoryName: zod_1.z.string().optional(),
    imageUrl: zod_1.z.string().optional(),
    unitsSold: zod_1.z.number(),
    revenue: zod_1.z.number(),
    cost: zod_1.z.number(),
    grossProfit: zod_1.z.number(),
    marginPct: zod_1.z.number(),
});
exports.MarginAnalysisReportSchema = zod_1.z.object({
    tenantId: zod_1.z.string(),
    locationId: zod_1.z.string(),
    from: zod_1.z.string(),
    to: zod_1.z.string(),
    totalRevenue: zod_1.z.number(),
    totalCost: zod_1.z.number(),
    grossProfit: zod_1.z.number(),
    marginPct: zod_1.z.number(),
    byCategory: zod_1.z.array(exports.MarginCategoryRowSchema),
    topMarginProducts: zod_1.z.array(exports.MarginProductRowSchema),
    worstMarginProducts: zod_1.z.array(exports.MarginProductRowSchema),
    negativeMarginAlerts: zod_1.z.array(exports.MarginProductRowSchema),
    trend: zod_1.z.array(zod_1.z.object({
        date: zod_1.z.string(),
        revenue: zod_1.z.number(),
        cost: zod_1.z.number(),
        marginPct: zod_1.z.number(),
    })),
});
//# sourceMappingURL=margin-analysis.schema.js.map